export enum fileTypes {
  unknown = 0,
  office = 1,
  video = 2,
  audio = 3,
  pdf = 4,
  zip = 5,
  image = 6,
  flash = 7
}

const categories: any[] = [
  {
    value: fileTypes.office,
    children: ['doc', 'docx', 'ppt', 'pptx', 'xlsx', 'xls']
  },
  {
    value: fileTypes.video,
    children: ['mp4', 'flv', 'swf']
  },
  {
    value: fileTypes.audio,
    children: ['mp3']
  },
  {
    value: fileTypes.pdf,
    children: ['pdf']
  },
  {
    value: fileTypes.zip,
    children: ['zip']
  },
  {
    value: fileTypes.image,
    children: ['png', 'gif', 'jpg', 'jpeg', 'bmp']
  },
  {
    value: fileTypes.flash,
    children: ['swf']
  }
]

export default categories
